export default __webpack_public_path__ + "static/media/WhitneySSm-Light-Adv_Web.748b5c80.woff";